import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const ProductLineAPI = {

  index: async function (cancel = false) {
    const response = await api.request({
      url: "/product-lines",
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },


  store: async function (data, cancel = false) {
    const response = await api.request({
      url: "/product-lines",
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  show: async function (product_line, cancel = false) {
    const response = await api.request({
      url: "/product-lines/" + product_line,
      method: "GET",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  update: async function (product_line, data, cancel = false) {
    const response = await api.request({
      url: "/product-lines/" + product_line,
      method: "PUT",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  delete: async function (product_line, cancel = false) {
    const response = await api.request({
      url: "/product-lines/" + product_line,
      method: "DELETE",
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(ProductLineAPI)